import React from 'react'

import ButtonM, { ButtonProps } from '@mui/material/Button'
import NoSsr from '@mui/material/NoSsr'
import CircularProgress from '@mui/material/CircularProgress'

import { ucfirst } from '@/src/fonction'
import COLORS from '@/src/colors'
import { useTheme } from '@mui/material/styles'

type Overwrite<T, U> = Pick<T, Exclude<keyof T, keyof U>> & U

type LocalProps = Overwrite<
  ButtonProps,
  {
    children: any
    color?: any
    subTitle?: string
    loading?: boolean
    select?: boolean
    testId?: string
    toUcfirst?: boolean
    // Attributs de lien, pour un bouton rendu en `<a>` (component="a" + href).
    target?: string
    rel?: string
  }
>

const Button: React.FC<LocalProps> = ({
  subTitle = '',
  children,
  loading = false,
  testId = 'buttonTester',
  toUcfirst = true,
  variant = 'contained',
  color = 'primary',
  size = 'medium',
  fullWidth = false,
  ...props
}) => {
  const theme = useTheme()
  const handleClick = args => {
    props.onClick && props.onClick(args)
  }

  let colorToUse = color
  const sxOverride: any = {}
  if (color === 'white') {
    colorToUse = 'primary'
    sxOverride.color = '#000'
    sxOverride.backgroundColor = '#fff'
    sxOverride['&:hover'] = {
      backgroundColor: theme.palette.background.paper,
      '@media (hover: none)': {
        backgroundColor: '#fff',
      },
    }
  }
  if (color === 'grey') {
    colorToUse = 'primary'
    sxOverride.color = '#000'
    sxOverride.backgroundColor = theme.palette.background.paper
    sxOverride['&:hover'] = {
      backgroundColor: COLORS.border2,
      '@media (hover: none)': {
        backgroundColor: theme.palette.background.paper,
      },
    }
  }
  if (color === 'greyDark') {
    colorToUse = 'primary'
    sxOverride.color = '#fff'
    sxOverride.borderRadius = 0
    sxOverride.textTransform = 'uppercase'
    sxOverride.backgroundColor = COLORS.loveWhilistSvg
    sxOverride['&:hover'] = {
      backgroundColor: COLORS.border2,
      '@media (hover: none)': {
        backgroundColor: COLORS.loveWhilistSvg,
      },
    }
  }
  return (
    <NoSsr>
      <ButtonM
        {...props}
        color={colorToUse}
        fullWidth={fullWidth}
        variant={variant}
        size={size}
        sx={sxOverride}
        disabled={props.disabled || loading}
        onClick={handleClick}
        data-testid={testId}
      >
        {loading ? (
          <CircularProgress size={20} />
        ) : (
          <>
            {toUcfirst ? ucfirst(children) : children}
            {!!subTitle && <div>{subTitle}</div>}
          </>
        )}
      </ButtonM>
    </NoSsr>
  )
}

export default Button
